export const achievementData = {
    bio : "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
    achievements : [
        {
            id : 1,
            title : 'User Experience UX for NonDesigners',
            details : 'LinkedIn',
            date : 'Nov 2021',
            field : 'UX',
            image : 'https://www.linkedin.com/in/shikher-mishra-540075140/details/certifications/'
        },
        {
            id : 2,
            title : 'Web technology',
            details : 'NIIT',
            date : 'June 2018',
            field : 'Development',
            image : 'https://www.linkedin.com/in/shikher-mishra-540075140/details/certifications/'
        },
        

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/